<template>
  <div 
    class="dropdown-item"
    :class="{ active: isActive, disabled: isEmpty }">
    <a
      v-if="isActive"
      @click.stop.prevent="change"
      v-bind:style="{ fontWeight: fontWeight }"
      class="skip-gtm-event"
      href="#_-_">
        <span class="circle-select"></span>{{ categoryName }} ({{ category.count }})
    </a>
    <a
      v-else
      @click.stop.prevent="change"
      v-bind:style="{ fontWeight: fontWeight }"
      class="skip-gtm-event"
      href="#_-_">
      <span class="circle-select"></span>{{ categoryName }} ({{ category.count }})
    </a>
    <input 
      type="hidden" 
      v-bind:name="inputName" 
      v-model="categoryId" 
      v-bind:disabled="disabled" />
  </div>
</template>

<script>
import Vue from 'vue';
import he from 'he';

export default {
  name: 'DropDownOption',
  props: {
    category: Object
  },
  data: function() {
    return {
      isActive: false,
      disabled: !this.isActive,
      categoryId: this.category.term_id,
      taxonomy: this.category.taxonomy
    }
  },
  beforeMount: function() {
    if ( this.isInStorage() ) {
      this.changeActive();
      this.changeDisabled();
      Vue.nextTick(() => {
        this.$root.$emit('add-filter', this );
      });
    }
  },
  computed: {
    fontWeight: function() {
      let fontWeight = 500;

      if ( undefined !== this.category.ndash && this.category.ndash.length > 0 ) {
        fontWeight = 300;
      }

      // if ( window.isMobile ) {
      //   fontWeight = 500;
      // }

      return fontWeight;
    },
    inputName: function() {
      let inputName = [];
      inputName.push(this.category.taxonomy.toLowerCase());

      if ( true == this.$parent.multiple || true == this.$parent.inputArray ) { 
        inputName.push('[]');
      }

      return inputName.join('');
    },
    isEmpty: function() {
      return this.category.count == 0;
    },
    categoryName: function() {
      let categoryName = [];

      if ( undefined != this.category.ndash ) {
        categoryName.push( he.decode( this.category.ndash ) );
      }

      categoryName.push( he.decode( this.category.name ) );

      return categoryName.join(' ');
    }
  },
  methods: {
    changeActive: function() {
      this.isActive = !this.isActive;
      this.$parent.changeMessage();
    },
    changeDisabled: function() {
      this.disabled = !this.isActive;
    },
    checkMultiple: function() {
      return this.$parent.multiple;
    },
    change: function() {
      // eslint-disable-next-line
      if ( !jQuery(this.$el).is('.disabled') ) {
        if ( ! this.checkMultiple() ) {
          this.$parent.emptyChildren( this )
        }
        this.changeActive();
        this.changeDisabled();
        if ( ! this.isActive ) {
          if( this.isRicercaStruttura() ) {
            window.dataLayer.push({'label': 'remove_selection'});
            window.dataLayer.push({'category': this.category.name});
          }
          this.removeFromStorage();
        }
        else {
          if( this.isRicercaStruttura() ) {
            window.dataLayer.push({'label': 'add_selection'});
            window.dataLayer.push({'category': this.category.name});
          }
          this.addToStorage();
        }
        Vue.nextTick(() => {
          this.$root.App.$emit('change-selection');
        });
      }
    },
    isRicercaStruttura: function() {
      var page_type = window.dataLayer.filter(function(item) {return item["page_type"] != undefined;}).pop();
      var is_ricerca_struttura = false;
      
      if( page_type["page_type"] == 'ricerca_struttura' ) {
        is_ricerca_struttura = true;
      }
      
      return is_ricerca_struttura;
    },
    isInStorage: function() {
      let categoryId = this.$root.App.session[ [ this.taxonomy, '[', this.categoryId, ']'].join('') ];
      return null != categoryId;
    },
    addToStorage: function() {
      this.$root.App.session[  [ this.taxonomy, '[', this.categoryId, ']'].join('') ] = this.categoryId;
    },
    removeFromStorage: function() {
      this.$root.App.session[ [ this.taxonomy, '[', this.categoryId, ']'].join('') ] = null;
    }
  }
}
</script>